async function postData(url = '', data = {}) {
  return await fetch(url, {
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
}

export async function loginOperator(username, password) {
  return postData('/api/authentication/login', {username, password, rememberMe: true});
}

export async function logoutOperator() {
  return postData('/api/authentication/logout', {});
}
